<div class="ig-panel">
  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.connectionSection" | translate }}
    </h3>

    @if (lastMicrosoftSync) {
      <div class="ig-status">
        <mat-icon>check_circle</mat-icon>
        <span>{{
          "settings.integration.microsoft.lastSync"
            | translate: { lastMicrosoftSync: lastMicrosoftSyncFormatted }
        }}</span>
      </div>
    }

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.microsoft.authorizeDomain" | translate }}
      </p>
      <div class="ig-toolbar">
        <button mat-stroked-button type="button" (click)="authorizeMicrosoft()">
          <img src="assets/img/microsoft.svg" alt="" class="ig-logo" />
          {{ "settings.integration.microsoft.authorizeButton" | translate }}
        </button>
      </div>
      @if (!lastMicrosoftSync) {
        <div class="ig-banner">
          <mat-icon>info</mat-icon>
          <span>
            {{
              "settings.integration.microsoft.adminPermissionInfo" | translate
            }}
            <button
              type="button"
              class="ig-link"
              (click)="openNotifyAdminDialog()"
            >
              {{ "settings.integration.microsoft.notifyAdminLink" | translate }}
            </button>
          </span>
        </div>
      }
    </div>

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.microsoft.syncEmployeeData" | translate }}
      </p>
      <div class="ig-toolbar">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="syncMicrosoft()"
          [disabled]="isMicrosoftSyncInProgress"
        >
          <mat-spinner
            *ngIf="isMicrosoftSyncInProgress"
            diameter="18"
            class="dc-btn-spinner"
          ></mat-spinner>
          <mat-icon *ngIf="!isMicrosoftSyncInProgress">sync</mat-icon>
          {{ "employee.sync-microsoft" | translate }}
        </button>
      </div>
    </div>

    @if (showMicrosoftProgress) {
      <app-sync-progress-bar
        [syncStateId]="microsoftSyncStateId"
        [provider]="'MICROSOFT'"
        (onClose)="closeMicrosoftProgress()"
        (onCompleted)="onMicrosoftSyncCompleted($event)"
      ></app-sync-progress-bar>
    }
  </section>

  @if (false) {
  <section class="form-section">
    <h3 class="section-title">
      {{
        "settings.integration.microsoft.serverSide.configurationTitle"
          | translate
      }}
    </h3>

    <div class="option-list">
      <mat-slide-toggle
        color="primary"
        [checked]="proxyEnabled && lastMicrosoftSync"
        (change)="toggleProxy($event.checked)"
      >
        {{
          "settings.integration.microsoft.serverSide.enableProxy" | translate
        }}
      </mat-slide-toggle>
      @if (proxyEnabled) {
        <mat-checkbox
          color="primary"
          [(ngModel)]="internalSignatureEnabled"
          (change)="toggleInternalSignature($event.checked)"
          [matTooltip]="
            'settings.integration.microsoft.serverSide.internalSignatureTooltip'
              | translate
          "
          matTooltipPosition="above"
        >
          {{
            "settings.integration.microsoft.serverSide.enableInternalSignature"
              | translate
          }}
        </mat-checkbox>
      }
    </div>

    @if (proxyEnabled) {
      <p class="section-hint">
        {{
          "settings.integration.microsoft.serverSide.configurationDescription"
            | translate
        }}
      </p>

      <mat-accordion class="ig-steps" multi>
        <mat-expansion-panel [class.ig-step--done]="microsoftStep1Completed">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.microsoft.serverSide.step1Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="microsoftStep1Completed"
              (change)="onMicrosoftStepChange()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{
                "settings.integration.microsoft.serverSide.step1Description"
                  | translate
              }}
              <a
                href="https://admin.exchange.microsoft.com/#/connectors"
                target="_blank"
                rel="noopener"
                >{{
                  "settings.integration.microsoft.serverSide.step1LinkText"
                    | translate
                }}</a
              >
            </p>
            <ul>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet1"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet2"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet3"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet4"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet5"
                    | translate
                }}
                <div class="ig-copy">
                  <span>IP</span>
                  <code>{{ proxyHostIp }}</code>
                  <button
                    type="button"
                    mat-icon-button
                    (click)="copyToClipboard(proxyHostIp)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet6"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet7"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step1Bullet8"
                    | translate
                }}
              </li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [class.ig-step--done]="microsoftStep2Completed">
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.microsoft.serverSide.step2Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="microsoftStep2Completed"
              (change)="onMicrosoftStepChange()"
              (click)="$event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{
                "settings.integration.microsoft.serverSide.step2Description"
                  | translate
              }}
              <a
                href="https://admin.exchange.microsoft.com/#/transportrules"
                target="_blank"
                rel="noopener"
                >{{
                  "settings.integration.microsoft.serverSide.step2LinkText"
                    | translate
                }}</a
              >
            </p>
            <ul>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet1"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet2"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet3"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet4"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet5"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet6"
                    | translate
                }}
                <div class="ig-copies">
                  <div class="ig-copy">
                    <span>{{
                      "settings.integration.microsoft.serverSide.proxySenderHeader"
                        | translate
                    }}</span>
                    <code>{{ xGSignatureHeader }}</code>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="copyToClipboard(xGSignatureHeader)"
                    >
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                  <div class="ig-copy">
                    <span>{{
                      "settings.integration.microsoft.serverSide.proxySenderValue"
                        | translate
                    }}</span>
                    <code>{{ xGSignatureValue }}</code>
                    <button
                      type="button"
                      mat-icon-button
                      (click)="copyToClipboard(xGSignatureValue)"
                    >
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet7"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet8"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet9"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet10"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet11"
                    | translate
                }}
              </li>
              <li>
                {{
                  "settings.integration.microsoft.serverSide.step2Bullet12"
                    | translate
                }}
              </li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.ig-step--done]="microsoftStep3Completed"
          [class.ig-step--error]="spfCheckResult === false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "settings.integration.microsoft.serverSide.step3Title" | translate
            }}</mat-panel-title>
            <mat-checkbox
              color="primary"
              [(ngModel)]="microsoftStep3Completed"
              [disabled]="true"
              (click)="$event.preventDefault(); $event.stopPropagation()"
            ></mat-checkbox>
          </mat-expansion-panel-header>
          <div class="ig-prose">
            <p>
              {{
                "settings.integration.microsoft.serverSide.step3Description"
                  | translate
              }}
              <a
                href="https://support.google.com/a/answer/33786"
                target="_blank"
                rel="noopener"
                >(link)</a
              >
            </p>
            <div class="ig-note">
              <p>
                {{
                  "settings.integration.microsoft.serverSide.step3Example"
                    | translate
                }}
              </p>
              <code>v=spf1 include:_spf.gsignature.com ~all</code>
            </div>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="verifySpfRecord()"
            >
              {{
                "settings.integration.microsoft.serverSide.checkSpfButton"
                  | translate
              }}
            </button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <p class="section-hint">
        {{
          "settings.integration.microsoft.serverSide.proxyDisclaimer" | translate
        }}
      </p>
    }

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveIntegrationSettings()"
        [disabled]="!canSaveServerSide"
        [class.loading-button]="savingProxy"
      >
        <mat-spinner
          *ngIf="savingProxy"
          diameter="18"
          class="dc-btn-spinner"
        ></mat-spinner>
        <mat-icon *ngIf="!savingProxy">save</mat-icon>
        {{ savingProxy ? ("saving" | translate) : ("save" | translate) }}
      </button>
    </div>
  </section>
  }
</div>
